// src/firebase.js

// Import Firebase functions
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Firebase configuration (use your actual keys)
const firebaseConfig = {
    apiKey: 'AIzaSyCJOcPM230-FIwIJyvdVbOMD3ukSKenDZ8',
    appId: '1:445590917284:web:b9e3404f457be517775631',
    messagingSenderId: '445590917284',
    projectId: 'wedding-dashboard-169f8',
    authDomain: 'wedding-dashboard-169f8.firebaseapp.com',
    databaseURL: 'https://wedding-dashboard-169f8-default-rtdb.firebaseio.com',
    storageBucket: 'wedding-dashboard-169f8.firebasestorage.app',
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// ✅ Export db so it can be imported in RSVP.jsx
export { db };